/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seemly_Mealy_Wallaby_FeastInputs */

const es_seemly_mealy_wallaby_feast = /** @type {(inputs: Seemly_Mealy_Wallaby_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de usuario`)
};

const gl_seemly_mealy_wallaby_feast = /** @type {(inputs: Seemly_Mealy_Wallaby_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de usuario`)
};

const en_seemly_mealy_wallaby_feast = /** @type {(inputs: Seemly_Mealy_Wallaby_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User name`)
};

/**
* | output |
* | --- |
* | "User name" |
*
* @param {Seemly_Mealy_Wallaby_FeastInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const seemly_mealy_wallaby_feast = /** @type {((inputs?: Seemly_Mealy_Wallaby_FeastInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seemly_Mealy_Wallaby_FeastInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_seemly_mealy_wallaby_feast(inputs)
	if (locale === "en") return en_seemly_mealy_wallaby_feast(inputs)
	return es_seemly_mealy_wallaby_feast(inputs)
});